import React from 'react'
import textloading from "../textloding.svg"
function Datafetching() {
  return (
    <div>
        <img src={textloading} alt='alt'/>
    </div>
  )
}

export default Datafetching